export const Calculate = (requestObject) => {

    requestObject ??= {};

    const result = {
        isValid: false,
        errors: [],
        result: null
    }

    requestObject.inputValue = parseFloat(`${requestObject.inputValue}`);

    if (Validate(requestObject, result)) {
        return result;
    }

    if (!requestObject.isMetric)
    {
        let resultInMm = ConvertInchesToMm(requestObject.inputValue);
        result.result = `${resultInMm} millimeters`;
    }

    if (requestObject.isMetric)
    {
        let resultInInches = ConvertMmToInches(requestObject.inputValue);
        result.result = `${resultInInches} inches`;
    }

    result.isValid = true;
    return result;
}

const Validate = (requestObject, result) => {
    if (isNaN(requestObject.inputValue)) {
        result.errors.push({
            id: "inputValue",
            message: "Please enter a valid number"
        })
    }
    return result.errors.length > 0
}

export const ConvertMmToInches = (number) => {
    return (Math.round((number / 25.4) * 100) / 100);
}

export const ConvertInchesToMm = (number) => {
    return (Math.round((number * 25.4) * 100) / 100);
}